import React from 'react';
import './Header.scss';
import { Link } from 'react-router-dom';
import logo from './Logo_diesel.svg';

const Header = () => {
  return (
    <div className="row align-center">
      <div className="column shrink">
        <div className="menu-wrapper">
          <ul className="main_menu">
            <li>
              <Link className="header__link" to="/services">Услуги</Link>
            </li>
            <li>
              <Link className="logo" to="/"><img src={logo} alt="Автошкола Дизель"/></Link>
            </li>
            <li>
              <Link className="header__link" to="/about">О нас</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx